import styled from "styled-components";

export const Wrapper = styled.div`
    max-width: 1216px;
    padding: 16px;
    margin: 0 auto;
`;